import { render, staticRenderFns } from "./airplaneBox.vue?vue&type=template&id=569df2e8&scoped=true"
import script from "./airplaneBox.vue?vue&type=script&lang=js"
export * from "./airplaneBox.vue?vue&type=script&lang=js"
import style0 from "./airplaneBox.vue?vue&type=style&index=0&id=569df2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569df2e8",
  null
  
)

export default component.exports